import { useEffect, useState } from "react";
import Api from "../openapi";

export default function useDislikes() {
  const [dislikeList, setDislikeList] = useState<string[]>([]);
  useEffect(() => {
    const getDislikes = async () => {
      try {
        const res = await Api.Dislike.getDislikes();
        setDislikeList(res.data);
      } catch (error) {}
    };
    getDislikes();
  }, []);
  return dislikeList;
}
